import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { useEffect } from 'react';
import { initLocalization } from '.';

export const LocalizationInitializer = () => {
  const { activeLanguages } = useRemoteConfig();

  useEffect(() => {
    if (activeLanguages?.length) {
      initLocalization(activeLanguages);
    }
  }, [activeLanguages]);

  return null;
};
